import { Component } from '@angular/core';
import { NavParams, NavController, LoadingController, AlertController, ToastController, Events, ModalController } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { Database } from '../../providers/database';
import { Utilities } from '../../providers/utilities';
import { Translate } from '../../providers/translate';
import { AuthData } from '../../providers/auth';
import { TranslateService } from '@ngx-translate/core';
import { EventResourcePage } from '../../pages/event-resource/event-resource';
import { EventNotesPage } from '../../pages/event-notes/event-notes';
import { EventQuestionsPage } from '../../pages/event-questions/event-questions';
import { EventOpinometerPage } from '../../pages/event-opinometer/event-opinometer';
import { Observable} from 'rxjs/Observable';

@Component({
  selector: 'event-activity',
  templateUrl: 'event-activity.html'
})
export class EventActivity {

  obs: any;
  obsActivity: any;
  obsListener: any;
  event: any;
  changeCount: any;
  client: any;
  dataActivity: any;
  componentState: any;
  timeLeft: any;
  textTranslate: any;

  constructor(public eventProvider: EventData, public params: NavParams, public ut: Utilities, public nav: NavController, public loadingCtrl: LoadingController, events: Events, translate: Translate, public db: Database, public alertCtrl: AlertController, public toastCtrl: ToastController, public translateProvider: TranslateService, public modal: ModalController, public auth: AuthData) {
		translate.translateGroup(['Cargando', 'Seleccione un opinómetro', 'Cancelar', 'Ok', 'Abrir', 'No se han encontrado opinómetros disponibles', 'Se han activado nuevas encuestas'])
    .then(result => {
      this.textTranslate = result;
    });

    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'activity').subscribe(stateModule => {
      this.closeListener(true);

      if (stateModule.$value === true) {
        this.obsActivity = this.eventProvider.getActivity(this.client, this.event.id).subscribe((data) => {
          this.dataActivity = data;
          this.verifiedOpinometer();
          this.componentState = true;
        });
      } else {
        this.dataActivity = false;
        this.componentState = false;
        console.log("Módulo Activity deshabilitado");
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  viewNotes() {
    this.nav.push(EventNotesPage, {event: this.event, client: this.client});
  }

  viewOpinometer() {
    let opinometerData = [];
    let loading = this.loadingCtrl.create({
      content: this.textTranslate['Cargando']
    });
    loading.present();
    let alert = this.alertCtrl.create({
      title: this.textTranslate['Seleccione un opinómetro']
    });

    if (this.dataActivity.opinometerState && this.dataActivity.opinometers.length > 0) {
      this.obs = new Observable(observer => {
        this.dataActivity.opinometers.forEach((opinometer: any, key) => {
          this.db.getData('/Clients/' + this.client.url + '/Opinometers/' + opinometer)
          .then((result: any) => {
            observer.next(result.val());

            if (key == this.dataActivity.opinometers.length-1) {
              observer.complete();
            }
          });
        });
      });

      this.obs.subscribe(
        (result) => {
          opinometerData = result;

          alert.addInput({
            type: 'radio',
            label: result.title[this.translateProvider.getDefaultLang()],
            value: result
          });
        }, {},
        () => {
          alert.addButton(this.textTranslate['Cancelar']);
          alert.addButton({
            text: this.textTranslate['Ok'],
            handler: selected => {
              if (selected) {
                let modal = this.modal.create(EventOpinometerPage, {event: this.event, client: this.client, opinometer: selected})
                modal.present();
              }
              loading.dismiss();
            }
          });
          if (this.dataActivity.opinometers.length > 1) {
            loading.dismiss().then(() => {
              alert.present();
            })
          } else {
            let modal = this.modal.create(EventOpinometerPage, {event: this.event, client: this.client, opinometer: opinometerData})
            loading.dismiss();
            modal.present();
          }
        }
      );
    } else {
      let toast = this.toastCtrl.create({
        message: this.textTranslate['No se han encontrado opinómetros disponibles'],
        position: 'top',
        duration: 5000,
        showCloseButton: true,
        closeButtonText: this.textTranslate['Ok']
      });

      toast.present().then(() => {
        loading.dismiss();
      });
    }
  }

  verifiedOpinometer() {
    if (this.dataActivity.opinometerState && this.dataActivity.opinometers.length > 0) {
      let flag = false;

      this.dataActivity.opinometers.forEach((opinometer: any, key) => {
        this.db.getData('/Clients/' + this.client.url + '/Opinometers/' + opinometer)
        .then((result: any) => {
          if (result.val().isAlert) {
            if (!flag) {
              flag = true;
              this.db.getData('/Clients/' + this.client.url + '/___OpinometersUsers/' + result.val().id + '/' + this.auth.getUser().uid).then((result2: any) => {
                if (!result2.val()) {
                  let alert = this.alertCtrl.create({
                    title: this.event.title,
                    buttons: [{
                      text: this.textTranslate['Cancelar'],
                      handler: () => {}
                    },{
                      text: this.textTranslate['Abrir'],
                      handler: () => {
                        this.viewOpinometer();
                      }
                    }]
                  });

                  if (this.dataActivity.opinometers.length > 1) {
                    alert.setMessage(this.textTranslate['Se han activado nuevas encuestas'])
                  } else {
                    alert.setMessage(result.val().message[this.translateProvider.getDefaultLang()])
                  }

                  alert.present();
                }
              });
            }
          }
        });
      });
    }
  }

  viewResources() {
    this.nav.push(EventResourcePage, {client: this.client, event: this.event, resources: this.dataActivity.resources, type: 'activity'});
  }

  closeListener(primaryListener = false) {
    if (this.obsListener && !primaryListener) {
      console.log('Se eliminan los observables de Embed');
      this.obsListener.unsubscribe();
    }
    if (this.obsActivity) {
      this.obsActivity.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-activity/event-activity.ts